/* global Nette, App */

(function () {
    if (typeof Nette === "undefined" || typeof Nette.initForm !== "function") return false;

    Nette.FormFocused = true;

    Nette.originalValidateForm = Nette.validateForm;

    Nette.validateForm = function (sender) {
        this.FormFocused = true;
        var form = sender.form || sender;
        $(form).find('.has-error').removeClass('has-error');
        $(form).find('.has-success').removeClass('has-error');
        $(form).find('.error-block').hide();
        var validate = this.originalValidateForm(sender);
        if (validate) {
            var submit = form['nette-submittedBy'];
            if (!$(submit).data("loading-text")) $(submit).attr("data-loading-text", $(submit).val());
            $(submit).button("loading");
        }
        return validate;
    };

    Nette.originalValidateControl = Nette.validateControl;

    Nette.validateControl = function (elem, rules, onlyCheck, value) {
        var validate = this.originalValidateControl(elem, rules, onlyCheck, value);
        if (validate) $(elem).closest('.form-group').addClass('has-success');
        return validate;
    };

    Nette.addError = function (elem, message) {
        if (this.FormFocused) {
            this.FormFocused = false;
            elem.focus();
        }
        var helpBlock = $(elem).parents('.form-group').find('.error-block');
        if (!helpBlock.length) {
            helpBlock = '<div class="help-block error-block">' + message + '</div>';
            $(elem).parents('.form-group').append(helpBlock);
        } else {
            helpBlock.show();
        }
        $(helpBlock).html(message);
        $(elem).parents('.form-group').addClass('has-error');
    };
})();
